export const SESSION_CREDENTIALS_MISSING_EVENT = 'cakto:session-credentials-missing';

// O `NotAuthenticated` do DRF chega sem `code` e com o `detail` traduzido pelo idioma do
// navegador. A mensagem é o que separa essa recusa da permissão negada e da trava de validação
// de cadastro, que também são 403 sem `code`.
const NOT_AUTHENTICATED_DETAILS = [
  'As credenciais de autenticação não foram fornecidas.',
  'Authentication credentials were not provided.',
  'Las credenciales de autenticación no se proveyeron.',
];

export const isMissingCredentialsError = (error) => {
  const status = error?.response?.status;
  if (status !== 401 && status !== 403) return false;

  const data = error?.response?.data || {};
  return data.code === 'not_authenticated' || NOT_AUTHENTICATED_DETAILS.includes(data.detail);
};

export const dispatchSessionCredentialsMissing = () => {
  if (typeof window === 'undefined') return;

  window.dispatchEvent(new CustomEvent(SESSION_CREDENTIALS_MISSING_EVENT));
};
